import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { SDKVersionGroup, SDKVersionGroupService } from '@app/core';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';

interface ISDKVersionGroupPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}

@Pipe({
    name: 'sdkVersionGroup', pure: false,
    standalone: false
})
export class SDKVersionGroupPipe
  extends AlloxCommonAsyncPipe<SDKVersionGroup>
  implements IAlloxAsyncPipeFetch<SDKVersionGroup>, PipeTransform {

  constructor(private service: SDKVersionGroupService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: number) {
    return this.service.fetch(value);
  }

  makeText(value: number, obj: SDKVersionGroup, option?: ISDKVersionGroupPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }

}
